<template>
  <div class="header-box-container">
    <div class="content-wrapper">
      <img class="logo" src="https://heartf.oss-cn-zhangjiakou.aliyuncs.com/logo%402x.png" />
      <div class="title">
        <div class="title-chn">北京心联智成心血管健康公益基金会</div>
        <div class="title-eng">Beijing Xinlian Zhicheng Cardiovascular Health Public Welfare Foundation</div>
      </div>
      <div class="search-wrapper">
        <input class="input-box" v-model="keyword" placeholder="请输入关键字进行搜索" @keyup.enter="gotoSearch" />
        <img class="icon" src="../../assets/search@2x.png" @click="gotoSearch" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderBox',
  data () {
    return {
      keyword: ''
    }
  },
  methods: {
    gotoSearch () {
      if (this.keyword) {
        this.$router.push({ name: 'search', query: {keyword: this.keyword} })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-box-container {
  .content-wrapper {
    width: 100%;
    height: 1.02rem;
    position: relative;
    .logo {
      position: absolute;
      top: 0.18rem;
      left: 1.14rem;
      width: 0.64rem;
      height: 0.64rem;
    }
    .title {
      position: absolute;
      top: 0.32rem;
      left: 1.9rem;
      text-align: justify;
      .title-chn {
        height: 0.2rem;
        font-size: 0.2rem;
        font-weight: bold;
        color: #00b7ee;
        &:after {
          display: inline-block;
          content: '';
          width: 100%;
          height: 0;
          overflow: hidden;
        }
      }
      .title-eng {
        height: 0.1rem;
        font-size: 0.1rem;
        color: #00b7ee;
        &:after {
          display: inline-block;
          content: '';
          width: 100%;
          height: 0;
          overflow: hidden;
        }
      }
    }
    .search-wrapper {
      position: absolute;
      top: 0.28rem;
      right: 1.14rem;
      width: 2.56rem;
      height: 0.43rem;
      border: 1px solid #e1e1e1;
      border-radius: 0.21rem;
      color: #e1e1e1;
      .input-box {
        margin: 0.12rem 0 0.12rem 0.2rem;
        width: 1.45rem;
        line-height: 0.2rem;
        font-size: 0.14rem;
      }
      .icon {
        position: absolute;
        top: 0.07rem;
        right: 0.18rem;
        width: 0.27rem;
        height: 0.27rem;
        cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HeaderBox/index.vue